<template>
	<div class="searchCenterBox">
		<div class="w-full bg-center bg-cover px-8 flex serchPage"
			style="min-height: 100vh;align-items: center;">
			<div class="flex flex-col items-center w-full">
        <img alt="" width="780" height="165" class="max-w-28 absolute top-4 left-4" style="color:transparent;width: 80px;" src="../../assets/logoW.png">
				
        <!-- 主标题 -->
        <div class="font-bold text-3xl md:text-4xl text-slate-600 mb-12 md:mb-16 text-center">查询中心</div>

				<!-- 查询板块 -->
				<div class="inputBox">
					<div class="serchBox">
						<input type="text" placeholder="请输入广告关键词查询" value="" class="serchContent" v-model="content">
						<div class="P2A_K1AX" @click="serch">查询</div>
					</div>
					<div class="serchBox">
						<input type="text" placeholder="请输入存证ID进行核验" value="" class="serchContent" v-model="id">
						<div class="P2A_K1AX" @click="heyan">核验</div>
					</div>
				</div>
				<!-- <div class="zhengshu">
					<div class="serchBox zsBox">
						<input type="text" placeholder="请输入证书编号查询" value="" class="serchContent" v-model="zsNum">
						<div class="P2A_K1AX zsBtn" @click="zsSerch">证书查询</div>
					</div>
				</div> -->

				<!-- AI资产证书查询 -->
				<div class="zhengshu">
					<div class="serchBox zsBox">
						<input type="text" placeholder="请输入AI资产证书编号查询" value="" class="serchContent" v-model="aiZsNum">
						<div class="P2A_K1AX zsBtn" @click="aiZsSerch">AI资产证书查询</div>
					</div>
				</div>

				<!-- 服务器查询 -->
				<div class="zhengshu">
					<div class="serchBox zsBox">
						<input type="text" placeholder="请输入服务器名称查询" value="" class="serchContent" v-model="agentName">
						<div class="P2A_K1AX zsBtn" @click="agentSerch">服务器查询</div>
					</div>
				</div>

				<!-- 两个卡片按钮 -->
				<div class="grid grid-cols-1 md:grid-cols-2 gap-8 w-full max-w-3xl mt-12">
					<router-link to="/chatIndex" target="_blank"
						class="BannerCard_bannerCard__8xTj1 relative rounded-2xl pt-6 pb-7 px-8 min-w-0 flex-1 bg-white/50 cursor-pointer"
						style="box-shadow:0 0 0 1px #f1f5f9, 0 2px 4px rgba(0, 0, 0, .05), 0 12px 24px rgba(0, 0, 0, .05)">
						<span style="outline:none"></span>
						<div class="text-xl font-bold mb-2 text-branding">开始对话</div>
						<div class="text-slate-500" style="font-size:15px">顶搜AI融合Deepseek 开启智能新纪元<br>体验全新旗舰模型<br></div>
						<div class="BannerCard_bannerCardOutline__YdEky absolute text-branding"></div>
					</router-link>
					<router-link to="/index"
						class="BannerCard_bannerCard__8xTj1 relative rounded-2xl pt-6 pb-7 px-8 min-w-0 flex-1 bg-white/50 cursor-pointer"
						style="box-shadow:0 0 0 1px #f1f5f9, 0 2px 4px rgba(0, 0, 0, .05), 0 12px 24px rgba(0, 0, 0, .05)">
						<span style="outline:none"></span>
						<div class="text-xl font-bold mb-2 text-branding">返回首页</div>
						<div class="text-slate-500" style="font-size:15px">了解关于我们的更多信息<br>查看完整介绍内容<br></div>
						<div class="BannerCard_bannerCardOutline__YdEky absolute text-branding"></div>
					</router-link>
				</div>
			</div>
			<!-- 右上角登录 -->
			<div class="flex gap-6 !absolute right-6 top-4">
				<router-link to="/index" class="ds-a ds-a--link text-sm !text-slate-400 cursor-pointer">
					<span aria-hidden="true" style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>首页
				</router-link>
				<router-link to="/chatIndex" v-if="userName==''" hreflang="en"
					class="ds-a ds-a--link text-sm !text-slate-400 cursor-pointer" href="#"><span aria-hidden="true"
						style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>登录/注册</router-link>
				<router-link to="/chatIndex" v-else hreflang="en"
					class="ds-a ds-a--link text-sm !text-slate-400 cursor-pointer" href="#"><span aria-hidden="true"
						style="position:fixed;user-select:none;-ms-user-select:none;-webkit-user-select:none;-moz-user-select:none;opacity:0;width:0;height:0;display:block"></span>{{userName}}</router-link>
			</div>
		</div>
		
		<!-- 弹窗组件 -->
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="zsLoadShow" @cancel="zsLoadCancle" :footer="null" wrapClassName="hyLoadBox" width="400px" centered>
				<div class="hyLoading"><img src="../../assets/loading.png" /></div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="aiZsLoadShow" @cancel="aiZsLoadCancle" :footer="null" wrapClassName="hyLoadBox" width="400px" centered>
				<div class="hyLoading"><img src="../../assets/loading.png" /></div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="zsShow" @cancel="zsCancle" :footer="null" centered>
				<div class="zsShow">
					<img :src="zsUrl" />
					<div class="download-btn-container">
						<button class="download-btn" @click="downloadImage(zsUrl, '证书.png')">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
								<polyline points="7 10 12 15 17 10"></polyline>
								<line x1="12" y1="15" x2="12" y2="3"></line>
							</svg>
							下载证书
						</button>
					</div>
				</div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="aiZsShow" @cancel="aiZsCancle" :footer="null" centered>
				<div class="zsShow">
					<img :src="aiZsUrl" />
					<div class="download-btn-container">
						<button class="download-btn" @click="downloadImage(aiZsUrl, 'AI资产证书.png')">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
								<polyline points="7 10 12 15 17 10"></polyline>
								<line x1="12" y1="15" x2="12" y2="3"></line>
							</svg>
							下载证书
						</button>
					</div>
				</div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="agentLoadShow" @cancel="agentLoadCancle" :footer="null" wrapClassName="hyLoadBox" width="400px" centered>

				<div class="hyLoading"><img src="../../assets/loading.png" /></div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="agentShow" @cancel="agentCancle" :footer="null" centered>
				<div class="zsShow">
					<img :src="agentUrl" />
					<div class="download-btn-container">
						<button class="download-btn" @click="downloadImage(agentUrl, '服务器证书.png')">
							<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
								<polyline points="7 10 12 15 17 10"></polyline>
								<line x1="12" y1="15" x2="12" y2="3"></line>
							</svg>
							下载证书
						</button>
					</div>
				</div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="hyData.loadShow" @cancel="loadCancle" :footer="null" wrapClassName="hyLoadBox" width="400px" centered>
				<div class="hyLoading"><img src="../../assets/loading.png" /></div>
			</a-modal>
		</a-config-provider>
		<a-config-provider :transition-name="['fade-enter', 'fade-leave']">
			<a-modal :visible="hyData.hyBoxShow" @cancel="hyCancle" :footer="null" wrapClassName="hyInfoBox" width="600px" centered>
				<div class="hyInfo">
					<div class="hyError" v-if="hyData.hyState=='0'">
						<div class="hyImg"><img src="../../assets/hyerror.png" /><div class="hyTip">暂无信息</div><div class="hyF" style="color: #e54545;">该证据未存证</div></div>
					</div>
					<div class="hySuccess" v-if="hyData.hyState=='1'">
						<div class="hyImg"><img src="../../assets/hysuccess.png" /><div class="hyTip">核验通过</div><div class="hyF">该证据自存证之日起未经篡改</div></div>
						<div class="hyLine"></div>
						<div class="hyDet">
							<div class="hyItem"><div class="hyLab">平台名称：</div><div class="hyText">{{hyData.hyName}}</div></div>
							<div class="hyItem"><div class="hyLab">交易Hash：</div><div class="hyText">{{hyData.jyHash}}</div></div>
						</div>
					</div>
				</div>
			</a-modal>
		</a-config-provider>
	</div>
</template>

<script>
	import { message } from 'ant-design-vue'

	export default {
		metaInfo: {
			title: '查询中心 - AI数字资产确权 证书查询 存证核验',
			meta: [
				{ 
					name: 'description', 
					content: '查询中心提供证书查询、AI资产证书查询、关键词核验、存证ID核验等服务，快速查验数字资产的权属信息' 
				},
				{ 
					name: 'keywords', 
					content: '证书查询,AI资产查询,数字资产核验,存证查询,区块链存证核验,确权证书,查询中心' 
				},
				{ property: 'og:title', content: '查询中心 - AI数字资产确权' },
				{ property: 'og:description', content: '专业的数字资产证书查询与存证核验服务' },
				{ property: 'og:type', content: 'website' }
			]
		},
		data() {
			return {
				content: '',
				id: '',
				zsNum: '',
				zsUrl: '',
				zsShow: false,
				aiZsNum: '',
				aiZsUrl: '',
				aiZsShow: false,
				zsLoadShow: false,
				aiZsLoadShow: false,
				agentName: '',
				agentUrl: '',
				agentShow: false,
				agentLoadShow: false,
				hyData: {
					hyName: '', hyValue: '', hyBoxShow: false, loadShow: false, hyState: '', time: '', id: '', czHash: '', jyHash: ''
				},
				token: '', userName: ''
			}
		},
		mounted() {
			if (localStorage.getItem('token')) {
				this.userName = localStorage.getItem('userName')
			}
		},
		methods: {
			loadCancle() { this.hyData.loadShow = false },
			hyCancle() { this.hyData.hyBoxShow = false },
			zsCancle() { this.zsShow = false },
			zsLoadCancle() { this.zsLoadShow = false },
			aiZsCancle() { this.aiZsShow = false },
			aiZsLoadCancle() { this.aiZsLoadShow = false },
			agentCancle() { this.agentShow = false },
			agentLoadCancle() { this.agentLoadShow = false },
			async downloadImage(imageUrl, fileName) {
				console.log(imageUrl)
				try {
					const response = await fetch(imageUrl);
					const blob = await response.blob();
					const url = window.URL.createObjectURL(blob);
					const link = document.createElement('a');
					link.href = url;
					link.download = fileName;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
					window.URL.revokeObjectURL(url);
					message.success('证书下载成功');
				} catch (error) {
					console.error('下载失败:', error);
					message.error('下载失败，请稍后重试');
				}
			},
			async serch() {
				let that = this
				if (!localStorage.getItem('token')) { message.error('请登录后查询'); return false }
				if (that.content.trim() == '') { message.error('请输入关键词查询'); return false }
				const res = await that.request({ method: "get", url: "https://ai.iptzx.com/api/index/wordSearch?key=" + that.content, headers: { token: localStorage.getItem('token') }, data: {} })
				if (res.data.data.key == true) { message.info('该关键词暂未注册') } else { message.error('该关键词已注册') }
			},
			async zsSerch() {
				let that = this
				if (!localStorage.getItem('token')) { message.error('请登录后查询'); return false }
				if (that.zsNum.trim() == '') { message.error('请输入证书编号查询'); return false }
				that.zsLoadShow = true
				const res = await that.request({ method: "get", url: "https://ai.iptzx.com/api/index/certSearch?key=" + that.zsNum, headers: { token: localStorage.getItem('token') }, data: {} })
				setTimeout(function() {
					that.zsLoadShow = false
					if (res.data.data != '') { that.zsUrl = res.data.data.info; that.zsShow = true } else { message.error(res.data.msg) }
				}, 1000)
			},
			async aiZsSerch() {
				let that = this
				if (!localStorage.getItem('token')) { message.error('请登录后查询'); return false }
				if (that.aiZsNum.trim() == '') { message.error('请输入AI资产证书编号查询'); return false }
				that.aiZsLoadShow = true
				const res = await that.request({ method: "get", url: "https://ai.iptzx.com/api/index/evIdSearch?key=" + that.aiZsNum, headers: { token: localStorage.getItem('token') }, data: {} })
				setTimeout(function() {
					that.aiZsLoadShow = false
					if (res.data.data && res.data.data.url) { that.aiZsUrl = res.data.data.url.url; that.aiZsShow = true } else { message.error(res.data.msg || '未找到证书信息') }
				}, 1000)
			},
			async agentSerch() {
				let that = this
				if (!localStorage.getItem('token')) { message.error('请登录后查询'); return false }
				if (that.agentName.trim() == '') { message.error('请输入服务器名称查询'); return false }
				that.agentLoadShow = true
				const res = await that.request({ method: "get", url: "https://ai.iptzx.com/api/index/agent?name=" + that.agentName, headers: { token: localStorage.getItem('token') }, data: {} })
				setTimeout(function() {
					that.agentLoadShow = false
					if (res.data.code === 1 && res.data.data && res.data.data.url) { 
						that.agentUrl = res.data.data.url; 
						that.agentShow = true 
					} else { 
						message.error(res.data.msg || '未找到服务器信息') 
					}
				}, 1000)
			},
			async heyan() {
				let that = this
				if (!localStorage.getItem('token')) { message.error('请登录后查询'); return false }
				if (that.id.trim() == '') { message.error('请输入存证ID进行核验'); return false }
				const res = await that.request({ method: "get", url: "https://ai.iptzx.com/api/index/evIdSearch?key=" + that.id, headers: { token: localStorage.getItem('token') }, data: {} })
				if (res.data.data.url == false) { message.error('请输入正确的存证ID查询'); return false }
				if (res.data.code == '0' && res.data.show == '0') {
					that.hyData.loadShow = true; that.hyData.hyState = '0'
					setTimeout(function() { that.hyData.loadShow = false; that.hyData.hyBoxShow = true }, 1500)
				}
				if (res.data.code == '1') {
					that.hyData.loadShow = true
					if (res.data.data == '') { that.hyData.hyState = '0' } 
					else { that.hyData.hyName = res.data.data.url.name; that.hyData.jyHash = res.data.data.url.hash; that.hyData.hyState = '1' }
					setTimeout(function() { that.hyData.loadShow = false; that.hyData.hyBoxShow = true }, 1500)
				}
			}
		}
	}
</script>

<style scoped>
	@import url('../../style/index (2).css');
	
	.searchCenterBox {
		min-height: 100vh;
	}
	.serchPage{
		background-image: url('../../assets/serchBanner.jpg');
	}
	
	a,.mx-auto,.text-auto{
		color: rgba(0, 0, 0, 0.65) !important;
	}
	
	.inputBox { display: flex; justify-content: space-between; width: 800px; margin: 0 auto; }
	.zhengshu { width: 800px; margin: 0 auto; }
	.serchBox { width: 390px; display: flex; margin-bottom: 30px; }
	.zsBox { width: 800px !important; }
	.zsBox input { width: 650px !important; }
	.zsBtn { width: 150px !important; }
	.serchBox input {
		width: 310px; height: 48px; box-sizing: border-box; background: #fff; border-radius: 6px 0 0 6px; border: none;
		outline: none; padding-left: 20px; font-size: 14px; color: #191a24;
	}
	.P2A_K1AX {
		background: #2468f2; border-radius: 0 6px 6px 0; font-family: PingFangSC-Regular; font-size: 16px; color: #fff;
		height: 48px; width: 80px; letter-spacing: 0; text-align: center; line-height: 48px; cursor: pointer; display: block;
	}
	@media screen and (max-width: 767px) {
		.inputBox, .zhengshu { max-width: 100%; display: block; }
		.serchBox { max-width: 100%; }
		.serchBox input { height: 42px; }
		.P2A_K1AX { height: 42px; line-height: 42px; font-size: 14px; white-space: nowrap; }
		.zsBtn { width: 180px !important; font-size: 13px !important; }
	}
	/* 弹窗样式保留 */
	.hyInfoBox .ant-modal-content { border-radius: 10px !important; }
	.hyInfoBox .ant-modal .ant-modal-body { background-image: linear-gradient(180deg, #dae5fd, #fff); background-repeat: no-repeat; background-size: 100% 150px; border-radius: 10px; }
	.hyImg { text-align: center; padding-top: 20px; }
	.hyImg img { width: 50px; margin: auto; }
	.hyTip { font-size: 20px; font-weight: 700; line-height: 40px; margin-top: 15px; }
	.hyF { font-size: 16px; }
	.hyLoading { text-align: center; }
	.hyLoading img { width: 300px; margin: auto; }
	.hyLine { border: none; border-bottom: 1px solid #e7eaef; margin: 20px 0; padding: 0; }
	.hyDet { display: table; font-size: 12px; line-height: 1.5; }
	.hyItem { display: table-row; }
	.hyLab { padding-right: 20px; padding-top: 6px; vertical-align: initial; display: table-cell; }
	.hyText { word-wrap: break-word; color: #000; padding-right: 12px; width: 100%; word-break: break-word; }
	
	.zsShow {
		text-align: center;
	}
	
	.zsShow img {
		width: 100%;
		/* max-height: 70vh; */
	}
	
	.download-btn-container {
		margin-top: 10px;
		padding-top: 10px;
		border-top: 1px solid #f0f0f0;
	}
	
	.download-btn {
		display: inline-flex;
		align-items: center;
		gap: 8px;
		padding: 12px 24px;
		background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
		color: white;
		border: none;
		border-radius: 8px;
		font-size: 16px;
		font-weight: 500;
		cursor: pointer;
		transition: all 0.3s ease;
	}
	
	.download-btn:hover {
		transform: translateY(-2px);
		box-shadow: 0 4px 12px rgba(59, 130, 246, 0.4);
		background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
	}
	
	.download-btn:active {
		transform: translateY(0);
	}
</style>
